import { Link } from "react-router-dom";
import { useState } from "react";
import { useCart } from "@/context/CartContext";
import { Stars } from "@/components/Stars";
import { ColorDots } from "@/components/ColorDots";
import { ShoppingBag, Check } from "@phosphor-icons/react";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();
  const [added, setAdded] = useState(false);
  const onSale = product.sale_price && product.sale_price > 0 && product.sale_price < product.price;
  const discount = onSale ? Math.round((1 - product.sale_price / product.price) * 100) : 0;

  const handleAdd = () => {
    addItem(product);
    setAdded(true);
    setTimeout(() => setAdded(false), 1600);
  };

  return (
    <div className="group fade-up" style={{ animationDelay: `${index * 60}ms` }} data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="relative block overflow-hidden bg-[#F0EFEB] aspect-[3/4] mb-4">
        {onSale && (
          <span className="absolute top-3 left-3 z-10 bg-[#991B1B] text-white text-[0.65rem] tracking-wider px-2.5 py-1 uppercase" data-testid={`sale-badge-${product.id}`}>
            Venta -{discount}%
          </span>
        )}
        <img
          src={product.images?.[0] || "https://images.unsplash.com/photo-1572726729207-a78d6feb18d7?q=80&w=800"}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          loading="lazy"
        />
      </Link>
      <div className="space-y-1.5">
        <div className="label-caps text-stone-400">{product.department}</div>
        <Link to={`/product/${product.id}`}>
          <h3 className="font-serif text-lg text-stone-900 leading-snug hover:text-[#3F4E4F]">{product.name}</h3>
        </Link>
        {product.colors?.length > 1 && <ColorDots colors={product.colors} size={12} />}
        {product.rating_count > 0 && (
          <div className="flex items-center gap-1.5">
            <Stars value={product.rating_avg || 0} size={13} />
            <span className="text-xs text-stone-400">({product.rating_count})</span>
          </div>
        )}
        <div className="flex items-center justify-between pt-1">
          {onSale ? (
            <span className="flex items-baseline gap-2" data-testid={`price-${product.id}`}>
              <span className="text-[#991B1B] font-medium">${product.sale_price.toFixed(2)}</span>
              <span className="text-stone-400 line-through text-sm">${product.price.toFixed(2)}</span>
            </span>
          ) : (
            <span className="text-stone-900 font-medium" data-testid={`price-${product.id}`}>${product.price?.toFixed(2)}</span>
          )}
          <button
            onClick={handleAdd}
            className={`flex items-center gap-1.5 text-xs transition-colors ${added ? "text-[#166534]" : "text-stone-600 hover:text-stone-900"}`}
            data-testid={`add-to-cart-${product.id}`}
          >
            {added ? <><Check size={16} /> ¡Agregado!</> : <><ShoppingBag size={16} /> Agregar</>}
          </button>
        </div>
      </div>
    </div>
  );
}
